import React, { useState } from 'react'
import classes from './PayloadSection.module.scss'
import Section from '@/components/ui/Section'
import { ReactComponent as EditorIcon } from '@/assets/icons/editor.svg'
import { RunCodeRequest } from '@/features/code-runner'
import { ReactComponent as ErrorIcon } from '@/assets/icons/warning.svg'
import Typography from '@/components/ui/Typography'
import { CodeEditor } from '@/features/code-editor'

export type PayloadSectionProps = {
  value: RunCodeRequest['request']
  setValue: (newValue: RunCodeRequest['request']) => void
  className?: string
  isEnabled: boolean
}

export const PayloadSection = ({ value, setValue, className, isEnabled }: PayloadSectionProps) => {
  const [inputValue, setInputValue] = useState(JSON.stringify(value ?? {}, null, 2))
  const [error, setError] = useState<string>()

  const handleChange = (value: string) => {
    setInputValue(value)

    // TODO Add debounce
    try {
      const json = JSON.parse(value.trim()) as RunCodeRequest['request']
      setValue(json)
      setError(undefined)
    } catch {
      setValue(undefined)
      setError('Should be valid JSON')
    }
  }

  return (
    <Section className={className}>
      <Section.Header title={'Payload'} icon={<EditorIcon />}></Section.Header>

      <Section.Content isCentered>
        {isEnabled ? (
          <div className={classes.codeEditor}>
            <CodeEditor
              //@ts-expect-error It is temporary solution until we build the UI for the payload
              config={{ types: [], language: 'json' }}
              initialValue={inputValue}
              onModelChange={handleChange}
            />
          </div>
        ) : (
          <Typography variant={'caption'}>{"Cron routes doesn't have payload"}</Typography>
        )}
      </Section.Content>

      {error && (
        <Section.Footer>
          <div className={classes.error}>
            <ErrorIcon /> Should be valid JSON
          </div>
        </Section.Footer>
      )}
    </Section>
  )
}
